<template>
  <!-- ПЕРВЫЙ ЗАПУСК МИНИ-АППА: спрашиваем, новый это игрок или у него уже есть аккаунт.
       🔴 ЗАЧЕМ ЭКРАН (решение оунера 2026-08-14): раньше вход из Telegram МОЛЧА заводил нового игрока,
       и человек со старым аккаунтом получал дубль, ещё ничего не нажав; вернуть его в свой аккаунт
       можно было только перевязкой. Спрашиваем ДО регистрации — тогда дубль не появляется вовсе. -->
  <div class="tgw">
    <div class="tgw__title">{{ $t('tgWelcome.title') }}</div>
    <div class="tgw__text">{{ $t('tgWelcome.text') }}</div>
    <button class="tgw__btn tgw__btn--main" :disabled="busy" @click="createNew">
      {{ $t('tgWelcome.newPlayer') }}
    </button>
    <button class="tgw__btn" :disabled="busy" @click="haveAccount">
      {{ $t('tgWelcome.haveAccount') }}
    </button>
    <div class="tgw__hint">{{ $t('tgWelcome.hint') }}</div>
    <div v-if="error" class="tgw__err">{{ error }}</div>
  </div>
</template>

<script>
import { telegramLogin } from '@/telegram';

export default {
  name: 'TelegramWelcome',
  emits: ['created', 'login'],
  data() {
    return { busy: false, error: '' };
  },
  methods: {
    // «Я новичок» — только теперь создаём игрока (сервер заводит его со всем: фигуры, дар, обучение).
    async createNew() {
      this.busy = true;
      this.error = '';
      const me = await telegramLogin(this.axios);
      this.busy = false;
      if (me && (me.access_token || me.jwt)) this.$emit('created');
      else this.error = this.$t('tgWelcome.failed');
    },
    // «У меня уже есть аккаунт» — показываем обычную форму входа и оставляем метку: после входа
    // логином и паролем Telegram привяжется сам (`linkTelegramAfterLogin` в App.vue).
    haveAccount() {
      localStorage.setItem('cz_tg_link_after_login', '1');
      this.$emit('login');
    },
  },
};
</script>

<style scoped lang="scss">
.tgw {
  max-width: 420px;
  margin: 0 auto;
  padding: 18px 16px 22px;
  text-align: center;
  color: #f3e9d2;

  &__title { font-size: 22px; margin-bottom: 10px; }
  &__text { font-size: 15px; line-height: 1.35; opacity: .9; margin-bottom: 18px; }
  &__hint { font-size: 12px; line-height: 1.35; opacity: .65; margin-top: 14px; }
  &__err { color: #ff9a9a; font-size: 13px; margin-top: 10px; overflow-wrap: anywhere; }

  &__btn {
    display: block;
    width: 100%;
    margin: 0 0 10px;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid #6b5a3a;
    background: #241a2e;
    color: #f3e9d2;
    font-size: 16px;
    cursor: pointer;

    &--main { background: #3a2b1c; border-color: #b08d4a; }
    &:disabled { opacity: .6; cursor: default; }
  }
}
</style>
